// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import axios from 'axios'
import fontawesome from '@fortawesome/fontawesome'
import faPlusSquare from '@fortawesome/fontawesome-free-solid/faPlusSquare'
import faChartBar from '@fortawesome/fontawesome-free-solid/faChartBar'
import errorHandle from '@/assets/errorHandle'

fontawesome.library.add(faPlusSquare)
fontawesome.library.add(faChartBar)

Vue.config.productionTip = false
Vue.use(iView)

Vue.mixin({
  data: function () {
    return {
      axios: axios
    }
  },
  methods: {
    setAxios (token) {
      this.axios.defaults.headers.common['x-access-token'] = token
    },
    errorHandle
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js